/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type CompositePropertyType = "APPT" | "BUILDING" | "COMMERCIAL" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "OTHER" | "PARK" | "PROP" | "ROOM";
export type OfferType = "buy" | "rent";
export type TypeOfPlace = "agglomeration" | "country" | "district" | "locality" | "municipality" | "neighbourhood" | "postcode" | "region" | "state";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingsAnalytics_aggregatesListings$ref: FragmentReference;
declare export opaque type AggregatesListingsAnalytics_aggregatesListings$fragmentType: AggregatesListingsAnalytics_aggregatesListings$ref;
export type AggregatesListingsAnalytics_aggregatesListings = {|
  +filters: {|
    +offerType_eq: OfferType,
    +salePrice_lte: ?number,
    +salePrice_gte: ?number,
    +createdAt_gte: ?string,
    +grossRentMonthly_lte: ?number,
    +grossRentMonthly_gte: ?number,
    +grossRentM2yearly_lte: ?number,
    +grossRentM2yearly_gte: ?number,
    +grossRentRoomMonthly_lte: ?number,
    +grossRentRoomMonthly_gte: ?number,
    +salePricePerLivingSurface_lte: ?number,
    +salePricePerLivingSurface_gte: ?number,
    +salePricePerLandSurface_lte: ?number,
    +salePricePerLandSurface_gte: ?number,
    +numberOfRooms_lte: ?number,
    +numberOfRooms_gte: ?number,
    +livingSurface_lte: ?number,
    +livingSurface_gte: ?number,
    +landSurface_lte: ?number,
    +landSurface_gte: ?number,
    +compositePropertyType_eq: ?CompositePropertyType,
    +portal_in: ?$ReadOnlyArray<?string>,
    +agencyReference_contains: ?string,
    +isNewDevelopment_eq: ?boolean,
    +hasBalcony_eq: ?boolean,
    +hasGarden_eq: ?boolean,
    +hasParking_eq: ?boolean,
    +hasElevator_eq: ?boolean,
    +hasView_eq: ?boolean,
    +hasFireplace_eq: ?boolean,
    +hasGarage_eq: ?boolean,
    +isChildFriendly_eq: ?boolean,
    +isWheelchairAccessible_eq: ?boolean,
    +isMinergieCertified_eq: ?boolean,
    +isFurnished_eq: ?boolean,
    +bookOnline_eq: ?boolean,
    +isFsbo_eq: ?boolean,
    +places: ?$ReadOnlyArray<{|
      +type: TypeOfPlace,
      +label: string,
      +municipality: ?{|
        +label: string
      |},
      +state: ?{|
        +label: string
      |},
    |}>,
  |},
  +totalCount: number,
  +edges: ?$ReadOnlyArray<?{|
    +node: {|
      +id: string,
      +encodedId: string,
    |}
  |}>,
  +$refType: AggregatesListingsAnalytics_aggregatesListings$ref,
|};
export type AggregatesListingsAnalytics_aggregatesListings$data = AggregatesListingsAnalytics_aggregatesListings;
export type AggregatesListingsAnalytics_aggregatesListings$key = {
  +$data?: AggregatesListingsAnalytics_aggregatesListings$data,
  +$fragmentRefs: AggregatesListingsAnalytics_aggregatesListings$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingsAnalytics_aggregatesListings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatesListingFilters",
      "kind": "LinkedField",
      "name": "filters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "offerType_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salePrice_lte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salePrice_gte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt_gte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "grossRentMonthly_lte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "grossRentMonthly_gte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "grossRentM2yearly_lte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "grossRentM2yearly_gte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "grossRentRoomMonthly_lte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "grossRentRoomMonthly_gte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salePricePerLivingSurface_lte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salePricePerLivingSurface_gte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salePricePerLandSurface_lte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salePricePerLandSurface_gte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfRooms_lte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfRooms_gte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "livingSurface_lte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "livingSurface_gte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "landSurface_lte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "landSurface_gte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "compositePropertyType_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "portal_in",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agencyReference_contains",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNewDevelopment_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasBalcony_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasGarden_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasParking_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasElevator_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasView_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasFireplace_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasGarage_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isChildFriendly_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isWheelchairAccessible_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMinergieCertified_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFurnished_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bookOnline_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFsbo_eq",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Place",
          "kind": "LinkedField",
          "name": "places",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": "municipality",
              "args": [
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "municipality"
                }
              ],
              "concreteType": "Place",
              "kind": "LinkedField",
              "name": "parentPlace",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": "parentPlace(type:\"municipality\")"
            },
            {
              "alias": "state",
              "args": [
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "state"
                }
              ],
              "concreteType": "Place",
              "kind": "LinkedField",
              "name": "parentPlace",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": "parentPlace(type:\"state\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatesListingConnectionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatesListing",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "encodedId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AggregatesListingConnectionConnection",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '0aa1838ad2b14d394828d00866b9e525';

export default node;
